import React from 'react';
export var Toggle = function (_a) {
    var enabled = _a.enabled, className = _a.className, containerRef = _a.containerRef;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "15", viewBox: "0 0 30 15", className: className, ref: containerRef },
        React.createElement("path", { fill: "none", fillRule: "evenodd", stroke: "currentColor", d: "M21.632 14.5H8.368C4.036 14.5.5 11.38.5 7.5s3.536-7 7.868-7h13.264c4.332 0 7.868 3.12 7.868 7s-3.536 7-7.868 7z" }),
        React.createElement("circle", { cx: "8.5", cy: "7.5", r: "4.5", fill: "#00E59B", fillRule: "evenodd", transform: enabled ? 'translate(13, 0)' : undefined, style: { transition: 'transform 0.2s ease-in-out' } })));
};
Toggle.displayName = 'Toggle';
export default Toggle;
//# sourceMappingURL=Toggle.js.map